import { ParseAdapter } from '../abstract/ParseAdapter';
import { Tchekb } from './tchekb.model';
import { Vehicle } from './vehicle.model';

export class DamageVehicle extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    // get vehiclePtr(): Vehicle {
    //     if ((this.parseObject.get instanceof Function) === false)
    //         return undefined
    //     else
    //         return new Vehicle(this.parseObject.get('vehiclePtr'));
    // }
    // set vehiclePtr(value: Vehicle) { this.parseObject.set('vehiclePtr', value.getParseInstance()); }

    // get progress(): number {
    //     if ((this.parseObject.get instanceof Function) === false)
    //         return undefined
    //     else
    //         return this.parseObject.get('progress');
    // }
    // set progress(value: number) { this.parseObject.set('progress', value); }

    // get type(): string {
    //     if ((this.parseObject.get instanceof Function) === false)
    //         return undefined
    //     else
    //         return this.parseObject.get('type');
    // }
    // set type(value: string) { this.parseObject.set('type', value); }

    get tchekPtr(): Tchekb {
        if ((this.parseObject.get instanceof Function) === false)
            return undefined
        else if (this.parseObject.get('tchekPtr'))
            return new Tchekb(this.parseObject.get('tchekPtr'));
    }
    set tchekPtr(value: Tchekb) { this.parseObject.set('tchekPtr', value.getParseInstance()); }


    tchekPtrId: String = this.parseObject.attributes.tchekPtr ? this.parseObject.attributes.tchekPtr.id : undefined;


    // get radius(): number {
    //     if ((this.parseObject.get instanceof Function) === false)
    //         return undefined
    //     else
    //         return this.parseObject.get('radius');
    // }
    // set radius(value: number) { this.parseObject.set('radius', value); }

    // get x(): number {
    //     if ((this.parseObject.get instanceof Function) === false)
    //         return undefined
    //     else
    //         return this.parseObject.get('x');
    // }
    // set x(value: number) { this.parseObject.set('x', value); }

    // get y(): number {
    //     if ((this.parseObject.get instanceof Function) === false)
    //         return undefined
    //     else
    //         return this.parseObject.get('y');
    // }
    // set y(value: number) { this.parseObject.set('y', value); }

    // get z(): number {
    //     if ((this.parseObject.get instanceof Function) === false)
    //         return undefined
    //     else
    //         return this.parseObject.get('z');
    // }
    // set z(value: number) { this.parseObject.set('z', value); }

}


// WEBPACK FOOTER //
// ./src/app/model/damageVehicle.model.ts